import { render } from "./AddSoftwareUpdateScheduleComponent.vue?vue&type=template&id=3ada1367&scoped=true"
import script from "./AddSoftwareUpdateScheduleComponent.vue?vue&type=script&lang=js"
export * from "./AddSoftwareUpdateScheduleComponent.vue?vue&type=script&lang=js"

import "./AddSoftwareUpdateScheduleComponent.vue?vue&type=style&index=0&id=3ada1367&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada1367"]])

export default __exports__